import React from 'react'
import styles from '../componentsStyles/Docs.module.css'

const Content = () => {
  return (
    <div className={styles.sections}>

        <div className={styles.section} id='doc-starting'>
          <label htmlFor=""> How to get started? </label>

          <div className={styles.wrapper}>
            <div className={styles.text}>
                <p >
                After the first contact, the customer will talk to a developer responsible for creating their product, in an attempt to make the right product while consuming the minimum amount of the customer's time, a project briefing will be carried out. A document containing common questions about the project will be sent to the client, and it will be possible to propose a meeting to discuss specific issues about the project, at the beginning (if the client prefers) or at specific stages.
                </p>
            </div>
          </div>

        </div>

        <div className={styles.section} id='doc-briefing'>
          <label htmlFor=""> What to respond on the project briefing?  </label>

          <div className={styles.wrapper}>
            <div className={styles.text}>

            <p>
            Details related to the type of device that will access the website (mobile phone, desktop tablet and others) are crucial to the general layout. Generally, web pages are made with a “mobile-first” approach. Other information describing you, your company or the objective of the project will help in the design and development process, resources such as images, logos and color schemes are always welcome.
                </p>
            </div>
          </div>

        </div>

        <div className={styles.section} id='doc-tools'>
          <label htmlFor=""> How the developer will be chosing the tools needed for my project? </label>

          <div className={styles.wrapper}>
            <div className={styles.text}>
                <p >
                Within the briefing phase, you will be asked about issues beyond the layout and appearance of your project, information such as expected traffic to the website, persistence of customer data (user authentication and stored information), security level and other related issues the overall objective of the project (such as email operations, integration with social media and connections with external sistems). All these questions serve to guide the developer to offer options for the final product.

                </p>
                <p>
                In simple projects such as local businesses, catalogs, personal or corporate websites will be evaluated differently than medium-sized ones, choosing the appropriate database, email services, authentication and other advanced features will require more work and continuous integration through tests, drastically interfering with the options available for you on deployment.

                </p>

            </div>
          </div>

        </div>

        <div className={styles.section} id='doc-finishing'>
          <label htmlFor="">  All the code needed is done, now how can i see my project live on the wild?</label>
          <div className={styles.wrapper}>
            <div className={styles.text}>
              <p > 
              Now that your project is completed, it is time to decide through the options given by the developer where your project will be active, depending on previous agreements, within the limitations of the technologies chosen for the project, you will be presented with some options these vary in price, available resources and other issues.

              </p>
              <p>
              All code made belongs to you, at the end of the contract, if the terms are met, you will have full access to the product's production repository, depending on the platform chosen, billing for hosting your project will be sent directly to the platform chosen by a account created explicitly for you, any financial decisions are up to you, all we will do is general project maintenance for you, at no extra cost, we only charge for new features and drastic changes to a project that is already live.

              </p>

            </div>
          </div>

        </div>

        <div className={styles.section} id ='doc-scaling'>
          <label htmlFor="">  My project is done, how can i build features or scale up?</label>

          <div className={styles.wrapper}>
            <div className={styles.text}>
              <p>
              This is one of the best features presented in modern systems, most architectures allow you to create new versions of the same product, developing and applying new features that can be redeployed more quickly, with basically no downtime.
              </p>
              <p>
              In case of poor results, it is possible, in some options, to revert the project to a previous state, leaving your business without downtime while corrections are applied.
              </p>
              <p> 
              It is important to note that as the project evolves, changes such as increased traffic expectations, greater data storage and other functionalities will require an increase in resource utilization, which may end up increasing the overall costs of the project. 
              </p>


            </div>
          </div>

        </div>

    </div>
  )
}

export default Content